import styles from "../add.module.css";
import { useForm } from "react-hook-form";
import moment from "moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { authData, authCustomerData } from "../../../../admin/components/GetAuth";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect } from "react";
import { StorageSetItem, STORAGE_KEYS } from "../../../../admin/components/StorageComp";
import { chargePayload, useBookingCharges } from "../../../../utils/bookingCharges";

const Step4 = ({ bookingData, charges, backToTab, setLoading, setSnackbarMessage, setSnackbarType, setSnackbarOpen, booking_id }) => {
  const auth = authData();
  const authCustomer = authCustomerData();
  const navigate = useNavigate();
  const [SubTotal, setSubTotal] = useState(0);
  const [Total, setTotal] = useState(0);
  const VATCharge = 0;
  const InsuranceCharge = 0;
  const [discountVal, setDiscountVal] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [referralDiscount, setReferralDiscount] = useState(0);
  const [subTotalNew, setSubTotalNew] = useState(0);
  const [productRDiscount, setProductRDiscount] = useState(0);
  const [pickupPhones, setPickupPhones] = useState([]);
  const [receipientPhones, setReceipientPhones] = useState([]);

  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "onChange" });
  const { loading: chargesLoading, error: chargesError, data: chargeData } = useBookingCharges(charges, bookingData?.pickUpData, bookingData?.recipientData);
  // Discounts only ever apply to the items; collection/delivery charges are added on top
  const chargesTotal = chargeData?.total || 0;

  useEffect(() => {
    let subtotalTemp = 0;
    let discountTemp = 0;
    let discountTemp2 = 0;

    bookingData?.products?.forEach((item) => {
      subtotalTemp += parseFloat(item.total);
    });
    setSubTotal(subtotalTemp);

    setDiscountVal(bookingData?.discountVal);
    setDiscountAmount(bookingData?.discountAmount);
    setReferralDiscount(bookingData?.referralDiscount);

    if (bookingData?.discountAmount) {
      discountTemp = bookingData?.discountAmount;
    }

    if (bookingData?.referralDiscount) {
      discountTemp2 = bookingData?.referralDiscount;
    }

    // Membership-discounted subtotal, used as the base for spreading the referral
    // discount proportionally across each line item (mirrors admin booking flow).
    let subTotalNewTemp = (bookingData?.products || []).reduce((sum, item) => {
      if (parseFloat(bookingData?.discountVal) > 0) {
        let newDisc = ((parseFloat(item.total) * parseFloat(bookingData?.discountVal)) / 100);
        newDisc = Math.round(newDisc * 100) / 100;

        return sum + parseFloat(item.total) - newDisc;
      }
      return sum + parseFloat(item.total);
    }, 0);

    setSubTotalNew(subTotalNewTemp);

    setTotal(subtotalTemp + VATCharge + InsuranceCharge - discountTemp - discountTemp2);

    if (bookingData && bookingData?.pickUpData?.phone) {
      let pPhones = [];

      if (bookingData?.pickUpData?.alt_phones && bookingData?.pickUpData?.alt_phones?.length > 0) {
        pPhones = bookingData?.pickUpData?.alt_phones?.map(i => i?.value);
      }

      setPickupPhones([bookingData?.pickUpData?.phone].concat(pPhones));
    }

    if (bookingData && bookingData?.recipientData?.phone) {
      let rPhones = [];

      if (bookingData?.recipientData?.alt_phones && bookingData?.recipientData?.alt_phones?.length > 0) {
        rPhones = bookingData?.recipientData?.alt_phones?.map(i => i?.value);
      }

      setReceipientPhones([bookingData?.recipientData?.phone].concat(rPhones));
    }
  }, [bookingData]);

  useEffect(() => {
    if (bookingData?.referralDiscount) {
      if (parseFloat(bookingData?.referralDiscount) > 0 && subTotalNew > 0) {
        let refDiscP = parseFloat(bookingData?.referralDiscount) / parseFloat(subTotalNew);
        refDiscP = Math.round(refDiscP * 10000) / 10000;

        setProductRDiscount(refDiscP);
      }
    }
  }, [bookingData?.referralDiscount, subTotalNew]);

  const onSubmit = (data) => {
    if (chargesLoading || chargesError) {
      setSnackbarOpen(true);
      setSnackbarMessage(chargesError || "Collection and delivery charges are still being calculated.");
      setSnackbarType("error");
      return;
    }

    let noOfItems = bookingData.products.length;
    let subTotal = 0;

    let products = bookingData.products.map((item) => {
      let newTotal = parseFloat(item.total);
      subTotal += parseFloat(item.total);
      let newDisc = 0;

      if (discountVal > 0) {
        let newDisc1 = ((newTotal * discountVal) / 100);
        newDisc1 = Math.round(newDisc1 * 100) / 100;

        newDisc += newDisc1;
        newTotal = newTotal - newDisc1;
      }
      if (productRDiscount > 0) {
        let newDisc2 = (newTotal * productRDiscount);
        newDisc2 = Math.round(newDisc2 * 100) / 100;

        newDisc += newDisc2;
        newTotal = newTotal - newDisc2;
      }

      let pObj = {
        product_id: item?.item_id,
        product_title: item?.item_name,
        price: item.total,
        quantity: 1,
        subtotal: item.total,
        discount: newDisc,
        sub_amount: newTotal,
        is_fragile: 0,
      };

      // Custom dimension-based items (category_id === -1) need their L/W/H sent
      // through so the backend can store/display them, same as the admin flow.
      if (item?.category_id === -1) {
        pObj = { ...pObj, length: item?.length, width: item?.width, height: item?.height, is_dimension: 1 };
      }

      if (bookingData?.freight_type === 'Air Freight') {
        pObj = { ...pObj, weight: item?.weight };
      }


      return pObj;
    });

    let alt_phones_p = bookingData?.pickUpData?.alt_phones?.map(i => i?.value);
    let alt_phones_r = bookingData?.recipientData?.alt_phones?.map(i => i?.value);

    let postData = {
      customer_id: authCustomer?.id,
      description: bookingData?.notes,
      no_of_items: noOfItems,
      insurance: bookingData?.insurance,
      company_shipping: bookingData?.company_shipping,
      company_name: bookingData?.company_name,
      registered_company: bookingData?.registered_company,
      pickup_date: moment(bookingData?.pickup_date).format("YYYY-MM-DD"),
      total: subTotal - (discountAmount || 0) - (referralDiscount || 0) + chargesTotal,
      amount: subTotal,
      post_code: bookingData?.pickUpData?.post_code,
      products: products,
      pickUpData: { ...bookingData?.pickUpData, alt_phones: alt_phones_p },
      recipientData: { ...bookingData?.recipientData, alt_phones: alt_phones_r },
      is_delivery: 0,
      discount_val: discountVal,
      discount_amount: discountAmount,
      referral_discount: referralDiscount,
      freight_type: bookingData?.freight_type || 'Sea Freight',
      ...chargePayload(chargeData),
    }

    setLoading(true);

    if (booking_id) {
      axios.post(process.env.REACT_APP_API_URL + "v1/customer/bookings/" + booking_id, postData, {
        headers: { Authorization: `Bearer ${auth?.api_token}` }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          navigate("/customer/my-bookings");
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message || "Something went wrong. Please try again.");
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMessage(error?.response?.data?.message || "Something went wrong. Please try again.");
        setSnackbarType("error");
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/customer/bookings", postData, {
        headers: { Authorization: `Bearer ${auth?.api_token}` }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");

          if (auth) {
            let authTemp = auth;
            let customerData = authTemp?.customer;
            if (customerData) {
              let referral_amount = customerData?.referral_amount;
              if (referral_amount) {
                referral_amount = parseFloat(referral_amount);
                referral_amount = referral_amount - parseFloat(referralDiscount);
              } else {
                referral_amount = 0;
              }
              if (referral_amount < 0) referral_amount = 0;

              customerData = { ...customerData, referral_amount: referral_amount, referral_point: referral_amount?.toFixed(2) };
            }
            authTemp = { ...authTemp, customer: customerData };
            StorageSetItem(STORAGE_KEYS.AUTH, authTemp, 24 * 60 * 60 * 1000);
          }

          navigate("/customer/my-bookings");
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message || "Something went wrong. Please try again.");
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        setSnackbarOpen(true);
        setSnackbarMessage(error?.response?.data?.message || "Something went wrong. Please try again.");
        setSnackbarType("error");
      });
    }
  }

  return (<>
    <div className={`${styles.CustomWidth}`}>
      <p className={styles.SectionLabel}>Review &amp; confirm</p>

      <div className={`${styles.SummerySec}`}>
        <div className={`${styles.SummerySecUnder}`}>
          <div className={`${styles.SummerySecRow}`}>
            {bookingData?.user_id?.label && <div className={`${styles.SummerySecFull}`}>
              <p>Customer Name:</p>
              <p>{bookingData?.user_id?.label}</p>
            </div>}
            <div className={`${styles.SummerySecFull}`}>
              <p>Freight Option: {bookingData?.freight_type || 'Sea Freight'}</p>
            </div>
            <div className={`${styles.SummerySecHalf} ${styles.SummerySecHalf1}`}>
              <p className={`${styles.StepBoxTitle2}`}>Sender details</p>
              <ul className={`${styles.SummeryListSec}`}>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.name}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.address}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Post Code:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.pickUpData?.post_code}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                  <p className={`${styles.SummeryHeadText}`}>{pickupPhones.join(', ')}</p>
                </li>
              </ul>
            </div>

            <div className={`${styles.SummerySecHalf}  ${styles.SummerySecHalf2}`}>
              <p className={`${styles.StepBoxTitle2}`}>Recipient details</p>
              <ul className={`${styles.SummeryListSec}`}>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Name:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.name}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Address:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.address}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Post Code:</p>
                  <p className={`${styles.SummeryHeadText}`}>{bookingData?.recipientData?.post_code}</p>
                </li>
                <li>
                  <p className={`${styles.SummeryHeadTitle}`}>Contact No:</p>
                  <p className={`${styles.SummeryHeadText}`}>{receipientPhones.join(', ')}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <p className={`${styles.StepBoxTitle}`}>Item details</p>
      <div className={`${styles.TableSec}`}>
        <table>
          <tbody>
            <tr>
              <td className={`${styles.TableHead}`}>Pickup Item</td>
              <td className={`${styles.TableHead}`}>Estimated Value</td>
            </tr>
            {bookingData?.products?.map((item, idx) => {
              let discTemp = 0;
              let newTotal = parseFloat(item.total);

              if (discountVal > 0) {
                let discTemp1 = ((newTotal * discountVal) / 100);
                discTemp1 = Math.round(discTemp1 * 100) / 100;

                discTemp += discTemp1;
                newTotal = newTotal - discTemp1;
              }

              if (productRDiscount > 0) {
                let discTemp2 = (newTotal * productRDiscount);
                discTemp2 = Math.round(discTemp2 * 100) / 100;

                discTemp += discTemp2;
              }

              return (<tr key={idx}>
                <td className={`${styles.TableCon}`}>
                  {item?.item_name}
                  {parseInt(item?.category_id) === -1 && <>
                    <br />
                    <span style={{ fontSize: '11px' }}>Dimension: <strong>L:{item?.length}cm</strong> <strong>W:{item?.width}cm</strong> <strong>H:{item?.height}cm</strong></span>
                  </>}
                  {bookingData?.freight_type === 'Air Freight' && item?.weight && <>
                    <br />
                    <span style={{ fontSize: '11px' }}>Weight: <strong>{item.weight} kg</strong></span>
                  </>}
                </td>
                <td className={`${styles.TableCon}`}>
                  &pound; {parseFloat(item.total).toFixed(2)}
                  {discountVal > 0 && <>
                    <br />
                    <p style={{ fontSize: '12px' }}>(-&pound; {parseFloat(discTemp).toFixed(2)})</p>
                  </>}
                </td>
              </tr>);
            })}
            <tr>
              <td className={`${styles.TableCon}`}>
                <p className={`${styles.SummeryPPTI}`}>Order Subtotal:</p>
                {discountVal > 0 && <p className={`${styles.SummeryPPTI}`}>Membership Discount({discountVal}%):</p>}
                {referralDiscount > 0 && <p className={`${styles.SummeryPPTI}`}>Referral Discount:</p>}
                {(chargeData?.collection?.enabled || chargeData?.delivery?.enabled) && <p className={`${styles.SummeryPPTI}`}>Item Total:</p>}
                {chargeData?.collection?.enabled && <p className={`${styles.SummeryPPTI}`}>Collection Charge{chargeData.collection.type === "mile" && chargeData.collection.miles !== null ? ` (${Number(chargeData.collection.miles).toFixed(2)} mi)` : ""}:</p>}
                {chargeData?.delivery?.enabled && <p className={`${styles.SummeryPPTI}`}>Delivery Charge{chargeData.delivery.type === "mile" && chargeData.delivery.miles !== null ? ` (${Number(chargeData.delivery.miles).toFixed(2)} mi)` : ""}:</p>}
                <p className={`${styles.SummeryPPTI}`}>Total VAT:</p>
                <p className={`${styles.SummeryPPTI}`}>Insurance Charges:</p>
                <p className={`${styles.SummeryPPTI} ${styles.Big}`}>Total:</p>
              </td>
              <td className={`${styles.TableCon}`}>
                <p className={`${styles.SummeryPPTE}`}>£{SubTotal.toFixed(2)}</p>
                {discountVal > 0 && <p className={`${styles.SummeryPPTE}`}>-£{discountAmount.toFixed(2)}</p>}
                {referralDiscount > 0 && <p className={`${styles.SummeryPPTE}`}>-£{referralDiscount.toFixed(2)}</p>}
                {(chargeData?.collection?.enabled || chargeData?.delivery?.enabled) && <p className={`${styles.SummeryPPTE}`}>£{Total.toFixed(2)}</p>}
                {chargeData?.collection?.enabled && <p className={`${styles.SummeryPPTE}`}>{chargesLoading ? "..." : `£${chargeData.collection.amount.toFixed(2)}`}</p>}
                {chargeData?.delivery?.enabled && <p className={`${styles.SummeryPPTE}`}>{chargesLoading ? "..." : `£${chargeData.delivery.amount.toFixed(2)}`}</p>}
                <p className={`${styles.SummeryPPTE}`}>£{VATCharge.toFixed(2)}</p>
                <p className={`${styles.SummeryPPTE}`}>£{InsuranceCharge.toFixed(2)}</p>
                <p className={`${styles.SummeryPPTE} ${styles.Big}`}>£{(Total + chargesTotal).toFixed(2)}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {chargesError && <p className={`${styles.ErrorM}`}>{chargesError}</p>}

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>To be collected:</p>
        <p className={`${styles.TableConSecText}`}>{moment(bookingData.pickup_date).format("ddd MMM D, YYYY")}</p>
      </div>

      <div className={`${styles.TableConSec}`}>
        <p className={`${styles.TableConSecTitle}`}>Booking Notes:</p>
        <p className={`${styles.TableConSecText}`}>{bookingData?.notes}</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControlLabel
          control={<Checkbox {...register("is_accept", { required: true })} />}
          label="I confirm that the order summary above is correct *"
          className={styles.CheckBox}
        />
        {errors?.is_accept && (<p className={styles.ErrorM}>Please accept terms & condition</p>)}

        <div className={`${styles.StepBUSec}`}>
          <button type="button" onClick={backToTab} className={`${styles.Previous}`}>Back</button>
          <button type="submit" className={`${styles.Next} ${styles.Confirm}`} disabled={chargesLoading || !!chargesError}>Confirm Booking</button>
        </div>
      </form>
    </div>
  </>);
}

export default Step4;